export enum IntegratedApp {
  Activations = 'ad_activation',
}

export const IntegratedAppsLinks = {
  [IntegratedApp.Activations]: import.meta.env.VITE_AD_ACTIVATION_URL || '',
}
